"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormTextField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _constants = require("../../constants");
var _FormLabelField = require("../FormLabelField");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const FormTextField = (param)=>{
    let { id, limit, label, required, disabled } = param;
    var _errors_id_message, _errors_id;
    const { getTestId } = (0, _testidGenerator.default)();
    const { errors } = (0, _reactHookForm.useFormState)({
        name: id
    });
    const { register } = (0, _reactHookForm.useFormContext)();
    const helperText = (_errors_id = errors[id]) === null || _errors_id === void 0 ? void 0 : (_errors_id_message = _errors_id.message) === null || _errors_id_message === void 0 ? void 0 : _errors_id_message.toString();
    const hasError = !!errors[id];
    const slotProps = (0, _react.useMemo)(()=>({
            htmlInput: {
                [_constants.DATA_TEST_ID]: getTestId(id),
                maxLength: limit
            }
        }), [
        getTestId,
        id,
        limit
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Stack, {
        spacing: 3,
        "data-testid": getTestId(_constants2.FORM_TEXT_FIELD),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormLabelField.FormLabelField, {
                required: required,
                label: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.TextField, {
                ...register(id),
                fullWidth: true,
                id: id,
                disabled: disabled,
                error: hasError,
                helperText: helperText,
                slotProps: slotProps,
                variant: "standard"
            })
        ]
    });
};
exports.FormTextField = FormTextField;
